import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-background text-muted" data-id="element-72" data-mp="3gezdb400vr15">
      <div className="h-px w-full bg-highlight" aria-hidden="true" data-id="element-73" data-mp="3ggtwodvnbb34" />
      <div className="mx-auto max-w-3xl px-4 py-8 text-center" data-id="element-74" data-mp="32onjn0nshk7w">
        <p className="text-xs" data-id="element-75" data-mp="36pfs3rou7l34">© 2026 {productShortName} — All rights reserved.</p>
      </div>
    </footer>;
}